import { normalizeEnvironment } from './normalizeEnv'

import type { EnvironmentWithChina } from '../App'

/**
 * Verbose console logging for customer-hub.
 *
 * These logs are diagnostic only and must never reach production, where they
 * are noise and can leak request details (tokens, account numbers, emails).
 * They stay enabled on `tst`/`acc` for support and QA.
 *
 * The active environment is supplied by the host app via
 * {@link configureDebugLogging} rather than read from `import.meta.env`,
 * because a single production build is pointed at any backend through the
 * `env` prop — so the build-time mode is not a reliable signal here.
 *
 * Real errors should keep using `console.error` directly: those are signal,
 * not noise, and are collected by Datadog in production.
 */
let enabled = false

export function configureDebugLogging(env: EnvironmentWithChina): void {
  enabled = normalizeEnvironment(env) !== 'prd'
}

export const debug = {
  log: (...args: unknown[]): void => {
    if (enabled) console.log(...args)
  },
  warn: (...args: unknown[]): void => {
    if (enabled) console.warn(...args)
  },
}
